import { Page, View } from "@react-pdf/renderer";
import { payments } from "lobbie";
import PDFFooter from "../base/PDFFooter";
import styles from "../base/styles";
import InvoiceHeader from "./InvoiceHeader";

interface IProps {
    invoiceDetails: payments.print.IInvoicePrintData;
    logoUrl?: string;
    business: payments.print.IBusinessData;
    children: React.ReactNode;
    receiptDetails?: payments.print.IPaymentRequest;
    timezone: string;
}

const InvoicePage: React.FC<IProps> = ({
    invoiceDetails,
    logoUrl,
    business,
    children,
    receiptDetails,
    timezone,
}) => {
    return (
        <Page size="LETTER" style={[styles.page, styles.textMed, styles.textMs]}>
            <InvoiceHeader
                invoiceDetails={invoiceDetails}
                logoUrl={logoUrl}
                business={business}
                receiptDetails={receiptDetails}
            />
            <View style={styles.flex1}>{children}</View>
            <PDFFooter timezone={timezone} />
        </Page>
    );
};

export default InvoicePage;
